import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { addOffer, getOfferList, updateOffer } from "./OfferRepo";
import { showToast } from "../../../utils/toastUtils";

export const useGetOffersList = ({
  enable = false,
  params,
}: {
  enable?: boolean;
  params?: any;
}) => {
  return useQuery({
    queryKey: ["OFFERS_LIST", params],
    queryFn: () => getOfferList(params),
    enabled: enable,
    retry: false,
  });
};

// addOffer
export const useAddOffers = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body?: any) => addOffer(body),
    onSuccess: () => {
      showToast.success("Add Offer Successfully!");
      queryClient.invalidateQueries({ queryKey: ["OFFERS_LIST"] });
    },
    onError: (error: any) => {
      console.log(`Failed To Add Offers  ${error.message}`);
      showToast.warning("Failed to Add Offer!");
    },
  });
};

// updateOffer
export const useUpdateOffers = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id?: string | number; body?: any }) =>
      updateOffer(id, body),
    onSuccess: () => {
      showToast.success("Update Offer Successfully!");
      queryClient.invalidateQueries({ queryKey: ["OFFERS_LIST"] });
    },
    onError: (error: any) => {
      console.log(`Failed To Update Offers  ${error.message}`);
      showToast.warning("Failed to Update Offer!");
    },
  });
};
